export const CITREA_CHAIN_ID = 4114
export const SQUID_API_BASE_URL = 'https://v2.api.squidrouter.com/v2'
export const SQUID_EXPLORER_URL = 'https://scan.squidrouter.com/tx'
export const SQUID_NATIVE_TOKEN_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
export const AMBIRE_FEE_TAKER_ADDRESS = '0x942f9CE5D9a33a82F88D233AEb3292E680230348'
